
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.pager{
  display:flex;
  width:100%;
  justify-content:center;
  margin-top:20px;
}

.js-pager__items,
.pager__items{
  width:100%;
  max-width:600px;
  display:flex;
  list-style-type:none;
  align-items:center;
  justify-content:center;
  column-gap:0.25rem;
  padding:0 !important;
}

.pager__item{
  font-size:var(--fs-base);
  position:relative;
  cursor:pointer;
}

.pager__item a{
    display:flex;
    text-decoration:none;
    width:max-content;
    color:inherit;
    padding:0.5rem 0.8rem;
  }

@media (min-width: 850px){

.pager__item a{
      padding:0.5rem 1rem
  }
    }

.pager__item a:focus{
      color:var(--brand-neutral-white);
      background-color:var(--brand-primary-2);
      outline-offset:-0.25rem;
      outline:white solid 2px;
    }

.pager__item a:focus::after{
        content:'';
        display:flex;
        background-color:var(--brand-primary-2);
        border:solid 1px var(--brand-primary-2);
        height:calc(100% + 2px);
        width:calc(100% + 2px);
        position:absolute;
        top:-1px;
        left:-1px;
        z-index:-1;
      }

.pager__item a:focus span[aria-hidden='true']{
        color:var(--brand-neutral-white) !important;
        padding:0.25rem 0;
        z-index:1;
      }

.pager__item:hover{
    color:var(--brand-neutral-white);
    background-color:var(--brand-primary-2);
  }

.pager__item:hover::after{
      content:'';
      display:flex;
      border:solid 1px var(--brand-primary-2);
      height:calc(100% + 2px);
      width:calc(100% + 2px);
      position:absolute;
      top:-1px;
      left:-1px;
      z-index:-1;
    }

.pager__item:hover > a > span[aria-hidden='true']{
      color:var(--brand-neutral-white) !important;
      padding:0.25rem 0;
    }

.pager__item.is-active{
    color:var(--brand-primary-2);
  }

.pager__item.is-active:hover{
      color:var(--brand-neutral-white);
    }

@media (min-width: 768px){

.pager__item.is-active{
      border:solid 1px var(--brand-primary-2)
  }
    }

@media (max-width: 767px){

.pager__item{
    display:none
}
  }

.pager__item--first,
.pager__item--last,
.pager__item--previous,
.pager__item--next,
.pager__item.is-active{
  display:flex !important;
}

@media (max-width: 767px){
  .pager__item--previous{
    padding-right:1.5rem !important;
  }
  .pager__item--next{
    padding-left:1.5rem !important;
  }
}

.pager__item--ellipsis:hover,
  .pager__item--ellipsis:focus{
    cursor:default !important;
    color:var(--brand-neutral-black) !important;
    background-color:var(--brand-neutral-white) !important;
  }

.pager__item--ellipsis:hover::after, .pager__item--ellipsis:focus::after{
      content:none !important;
    }

span[aria-hidden='true']{
  font-size:32px;
  color:var(--brand-primary-2);
  font-weight:var(--fw-black);
  letter-spacing:1px;
  font-family:var(--ff-rift);
  line-height:0.5;
}

span[aria-hidden='true']:hover,
  span[aria-hidden='true']:focus{
    color:var(--brand-neutral-white) !important;
    background-color:var(--brand-primary-2);
  }

.visually-hidden{
  display:none;
}
`;